export default "__VITE_ASSET__DpRaewzj__"